import { Box } from '@mui/material';
import {
  isNerdyTipAndProgressBarActive,
  isProgressBarOnlyActive,
} from 'src/lib/experiments';
import { useAppSelector } from 'src/redux/hooks';
import { getExperiments } from 'src/redux/selectors';

const NAV_HEIGHT = '80px';

type FlowContainerProps = {
  children?: React.ReactNode;
  header?: React.ReactNode;
  backgroundColor?: string;
};

const FlowContainer: React.FC<FlowContainerProps> = ({
  backgroundColor = 'common.white',
  children,
  header,
}) => {
  const experiments = useAppSelector(getExperiments);
  return (
    <Box
      sx={(theme) => ({
        backgroundColor,
        paddingTop:
          isNerdyTipAndProgressBarActive(experiments) ||
          isProgressBarOnlyActive(experiments)
            ? 4
            : 0,
        [theme.breakpoints.down('sm')]: {
          position: 'fixed',
          width: '100%',
          height: '100%',
          overflow: 'scroll',
          top: 0,
          left: 0,
          bottom: 0,
          display: 'flex',
          flexDirection: 'column',
          zIndex: 900,
          paddingTop:
            isNerdyTipAndProgressBarActive(experiments) ||
            isProgressBarOnlyActive(experiments)
              ? 0
              : 2,
        },
      })}
    >
      {header}
      <Box
        sx={(theme) => ({
          [theme.breakpoints.down('sm')]: {
            display: 'flex',
            flexDirection: 'column',
            height: '100%',
            justifyContent: 'space-between',
          },
          [theme.breakpoints.up('sm')]: {
            minHeight: `calc(100vh - ${NAV_HEIGHT})`,
            paddingX: 4,
            paddingBottom: 4,
            maxWidth: 1280,
            marginX: 'auto',
          },
        })}
      >
        {children}
      </Box>
    </Box>
  );
};

export default FlowContainer;
